import script from "./RequestConfirmed.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestConfirmed.vue?vue&type=script&setup=true&lang=ts"

import "./RequestConfirmed.vue?vue&type=style&index=0&id=82b8ebf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82b8ebf0"]])

export default __exports__